import { ReactElement } from 'react';

import { ReactionTypes } from 'api';
import { ReactComponent as EmptyHeartIcon } from 'assets/icons/postReactions/emptyheart.svg';
import { theme } from 'styles';

interface ReactionInlineProps {
  type: ReactionTypes | null;
}

export function ReactionInline({ type }: ReactionInlineProps): ReactElement {
  switch (type) {
    case ReactionTypes.HEART:
    case ReactionTypes.LIKE:
      return (
        <EmptyHeartIcon
          style={{
            width: '20px',
            height: '20px',
            color: theme.palette.info.main,
          }}
        />
      );
    default:
      return (
        <EmptyHeartIcon
          style={{
            width: '20px',
            height: '20px',
            color: theme.palette.primary.grey,
          }}
        />
      );
  }
}
